import React, { useState } from 'react';

type Props = {
  onConferma: (categoriaSelezionata: string) => void;
  onAnnulla: () => void;
};

const categorieMercati = [
  { key: 'equity', label: 'Azioni' },
  { key: 'bonds', label: 'Obbligazioni' },
  { key: 'derivatives', label: 'Derivati' },
  { key: 'others', label: 'Altri mercati' },
];

const SelectCategoriaDialog = ({ onConferma, onAnnulla }: Props) => {
  const [selectedCategoria, setSelectedCategoria] = useState<string>(categorieMercati[0].key);

  return (
    <div className="text-center">
      <h2 className="text-xl font-semibold mb-4">Seleziona categoria mercato</h2>
      <p className="mb-4">Scegli la categoria di mercato a cui aggiungere la venue:</p>
      <select
        value={selectedCategoria}
        onChange={e => setSelectedCategoria(e.target.value)}
        className="mb-6 p-2 border border-gray-300 rounded w-48"
      >
        {categorieMercati.map(cat => (
          <option key={cat.key} value={cat.key}>
            {cat.label}
          </option>
        ))}
      </select>
      <div className="flex justify-center space-x-4">
        <button
          onClick={onAnnulla}
          className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
        >
          Annulla
        </button>
        <button
          onClick={() => onConferma(selectedCategoria)}
          className="px-4 py-2 bg-textPrimary text-white hover:bg-textSecondary rounded"
        >
          Conferma
        </button>
      </div>
    </div>
  );
};

export default SelectCategoriaDialog;
